/* eslint-disable */


/**
 * Create styles for `<OktaSignInWidget />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OktaSignInWidget />` styles
 */
const oktaSignInWidgetStyles = ({ theme }) => ({
  [`@global`]: {
    [`#okta-sign-in .beacon-loading:after`]: {
      borderTopColor: theme.palette.primary.main,
    },
    [`#okta-sign-in.auth-container .button.button-primary.link-button-disabled`]: {
      background: theme.palette.primary.main,
      opacity: 0.5,
    },
    [`#okta-sign-in.auth-container .button-primary`]: {
      [`&:hover`]: {
        background: `green`,
      },
      background: theme.palette.primary.main,
      border: `unset`,
      borderRadius: `unset`,
      boxShadow: `unset`,
    },
  },
});

export default oktaSignInWidgetStyles;
